import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { WidgetsModule } from '../../../../widgets/widgets.module';
import { AutoTagModelDialogComponent } from './autotag-model-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        AutoTagModelDialogComponent,
    ],
    exports: [
        AutoTagModelDialogComponent,
    ]
})
export class AutoTagModelDialogModule { }
